// Email pattern
const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{0,4}$/;

// Password pattern
const passwordPattern = /^(?=.*[A-Z])(?=.*\d).{8,}$/;

// Tel pattern
const telPattern = /^[0-9]*$/;

export { emailPattern, passwordPattern, telPattern };
